import { Spin } from "antd";
import React, { useState } from "react";
import { requests } from "../../../../configs/constants";
import { requestApiUpsellProvider } from "../../../../lib/api/providers";
import EditPdc from "../Edit.detailpdc";

const Creation = ({ request, token, returnToList, updatePdcCreation }) => {
  const [isLoading, setIsLoading] = useState(false);

  const [updatedData, setUpdatedData] = useState(request.data || {});

  return (
    <div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <h2 style={{ fontSize: 20, fontWeight: "bold", margin: 20 }}>Demande de création</h2>
      </div>
      <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginBottom: 20 }}>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-around" }}>
          <div>Demande faite par : {request.infos.user_email}</div>
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
          <div style={{ marginRight: 20 }}>
            <EditPdc
              token={token}
              pdc={request.data}
              onSubmit={pdc => {
                setUpdatedData(pdc);
                updatePdcCreation(pdc);
              }}
            ></EditPdc>
          </div>
          {isLoading ? (
            <Spin></Spin>
          ) : (
            <div
              style={{ marginRight: 20 }}
              className="p-btn p-btn-red"
              onClick={async () => {
                setIsLoading(true);
                try {
                  await requestApiUpsellProvider.post(
                    "/reject",
                    { _id: request._id, type: requests.PDC_CREATION },
                    {
                      headers: {
                        Authorization: token
                      }
                    }
                  );
                  returnToList();
                  setIsLoading(false);
                } catch (e) {
                  console.log("error", e);
                  setIsLoading(false);
                }
              }}
            >
              Refuser
            </div>
          )}
          {isLoading ? (
            <Spin></Spin>
          ) : (
            <div
              style={{ marginRight: 20 }}
              className="p-btn p-btn-green"
              onClick={async () => {
                setIsLoading(true);
                try {
                  await requestApiUpsellProvider.post(
                    "/validate",
                    { _id: request._id, type: requests.PDC_CREATION, data: updatedData },
                    {
                      headers: {
                        Authorization: token
                      }
                    }
                  );
                  returnToList();
                  setIsLoading(false);
                } catch (e) {
                  console.log("error", e);
                  setIsLoading(false);
                }
              }}
            >
              Valider
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Creation;



// WEBPACK FOOTER //
// src/pages/basepdc/detailPdc/Request.js/Creation.request.js